import React, { Component } from "react";
import QVFourPhotoSection from "views/Pma/PmaEditor/Quarterly/QVFour/QVFourSecondPage/QVFourPhotoSection";

import AgentLogoHeader from "views/Pma/PmaEditor/ThirdPageComponents/AgentLogoHeader";
import QVFourPS from "views/Pma/PmaEditor/Quarterly/QVFour/QVFourSecondPage/QVFourPS";
import QVFourPhotos from "views/Pma/PmaEditor/Quarterly/QVFour/QVFourSecondPage/QVFourPhotos";
import YETwoShortenedMarketTableV2 from "views/Pma/PmaEditor/YearEnd2022/YETwo/YETwoSecondPage/YETwoShortenedMarketTableV2";
import MQThreeAvailableHomes from "views/Pma/PmaEditor/ThirdPageComponents/MQThreeAvailableHomes";
import QRCode from "views/Pma/PmaEditor/ThirdPageComponents/QRCode";
import MarketIndicators from "views/Pma/PmaEditor/YearEnd2022/YETwo/YETwoSecondPage/YETwoMarketIndicators";
import QVFourEmailAndWebsiteFooter from "views/Pma/PmaEditor/SecondPageComponents/QVFourEmailAndWebsiteFooter";

class YETwoSecondLeftV2 extends Component {
  sortByStatus = (propList) => {
    const { mlsAreaID } = this.props.currentArea;
    const { listgenUserID } = this.props.agentData;
    let maxTableRows = 13;
    const {
      activePhotoDetailsList,
      contingentPhotoDetailsList,
      pendingPhotoDetailsList,
      preSoldPhotoDetailsList,
      recentSoldPhotoDetailsList,
      agentFilteredPhotoDetailsList,
    } = this.props.quarterlyAreaTable;
    let sliced = propList
      .slice()
      .sort((a, b) => new Date(b.saleDate) - new Date(a.saleDate));
    let isLoriB = listgenUserID === "102548";
    let sold = recentSoldPhotoDetailsList ? recentSoldPhotoDetailsList : [];
    let pend = pendingPhotoDetailsList ? pendingPhotoDetailsList : [];
    let cont = contingentPhotoDetailsList ? contingentPhotoDetailsList : [];
    let active = isLoriB
      ? activePhotoDetailsList.slice(0, 1)
      : activePhotoDetailsList
      ? activePhotoDetailsList
      : [];
    let laterSold = preSoldPhotoDetailsList ? preSoldPhotoDetailsList : [];
    let agentsProps = agentFilteredPhotoDetailsList
      ? agentFilteredPhotoDetailsList
      : [];
    // console.log("sold", sold);
    // console.log("pend", pend);
    // console.log("cont", cont);
    // console.log("agentsProps", agentsProps);
    // console.log("active", active);
    // console.log("laterSold", laterSold);
    let last45DaysSum =
      (agentFilteredPhotoDetailsList ? agentFilteredPhotoDetailsList : 0) +
      (activePhotoDetailsList ? activePhotoDetailsList.length : 0) +
      (contingentPhotoDetailsList ? contingentPhotoDetailsList.length : 0) +
      (pendingPhotoDetailsList ? pendingPhotoDetailsList.length : 0) +
      (recentSoldPhotoDetailsList ? recentSoldPhotoDetailsList.length : 0);

    let remainderPreSold = maxTableRows - last45DaysSum;

    const sortByStatusThenDate = (data) => {
      let sortedSolds = data
        .filter((x) => x.status === "Sold")
        .sort((a, b) => new Date(b.saleDate) - new Date(a.saleDate));

      let newConstructed = [
        ...data.filter((x) => x.status === "Active"),
        ...data.filter(
          (x) => x.status === "Pending" || x.status === "Contingent"
        ),
        ...sortedSolds,
      ];
      let uniqueProps = newConstructed.filter(
        (obj1, i, arr) =>
          arr.findIndex(
            (obj2) =>
              obj2.streetNumber === obj1.streetNumber &&
              obj2.streetName === obj1.streetName &&
              obj2.status === obj1.status &&
              obj2.unitNumber === obj1.unitNumber
          ) === i
      );

      return uniqueProps;
    };

    function sortByPropTypeThenDate(arr) {
      let order = ["Single Family Home", "Townhouse", "Condo/Co-Op"];
      let key = "propertyType";
      const orderMap = order.reduce((acc, val, index) => {
        acc[val] = index;
        return acc;
      }, {});

      arr.sort((a, b) => orderMap[a[key]] - orderMap[b[key]]);
      return arr;
    }

    const trimAgentProps = (agentRelatedProps) => {
      if (listgenUserID === "100075") {
        var startDate = new Date("2024-05-01");
        let filteredByDate = agentRelatedProps.filter((a) => {
          var date = new Date(a.saleDate);
          return date >= startDate || a.status !== "Sold";
        });

        return filteredByDate;
      } else {
        return agentRelatedProps;
      }
    };

    let agentPropsLength = agentsProps.length;
    let activePropsLength = active.length;
    let trimmedProps = trimAgentProps(agentsProps);

    let trueSort1 = [
      ...trimmedProps,
      ...active,

      ...pend,
      ...cont,
      ...sold,
      ...laterSold,
    ];
    let sortByPropType = false;
    if (mlsAreaID === "SMA-392") {
      sortByPropType = true;
    }

    let slicedSort = trueSort1.slice(0, maxTableRows);

    let trueSort = sortByPropType
      ? sortByPropTypeThenDate(slicedSort)
      : sortByStatusThenDate(slicedSort);

    return trueSort;
  };
  render() {
    const {
      currentArea,
      agentData,
      printVersion,
      version,
      hoData,
      mlsAreas,
      aprilData,
      demoAccountHOName,
      propertyPhotoDetailsDTO,
      oldPhotoDetails,
      photoTableData,
      quarterlyAreaTable,
      quarterlyCityTable,
      MQCityDetails,
      isDemo,
    } = this.props;
    const { listgenUserID } = agentData;
    const { mlsAreaID } = currentArea;
    const { currentSoldListings } = quarterlyAreaTable;
    let useExtendedTable = false;

    let sorted =
      currentSoldListings && currentSoldListings
        ? this.sortByStatus(currentSoldListings, false, true)
        : [];

    // let useExtendedTable =
    //   currentSoldListings && currentSoldListings
    //     ? this.sortByStatus(currentSoldListings, true)
    //     : [];
    // let isBellaterra = mlsAreaID === "SCL-16M";
    // if (isBellaterra) {
    //   useExtendedTable = false;
    // }
    let isSame = photoTableData === currentSoldListings;

    let useCity = false;
    if (mlsAreaID === "SBA-40F" || mlsAreaID === "SBA-40G") {
      useCity = true;
    }
    let isGailPearl = listgenUserID === "x103455";
    let middleSectionStyles;
    if (isGailPearl) {
      middleSectionStyles = "compact-middle-section";
    }

    return (
      <div
        className={`${version === "year-end-2022" ? "ye2" : "qv4"}-second-left`}
      >
        <div
          className={`mq3-second-left-middle-section ${middleSectionStyles}`}
        >
          <YETwoShortenedMarketTableV2
            quarterlyCityTable={quarterlyCityTable}
            currentArea={currentArea}
            quarterlyAreaTable={
              useCity ? quarterlyCityTable : quarterlyAreaTable
            }
            useCity="false"
            hoData={hoData}
            agentData={agentData}
            MQCityDetails={MQCityDetails}
            lastMidQuarterlyPrintDate={
              quarterlyAreaTable.lastMidQuarterlyPrintDate
            }
            //printDate="Nov 1, 2021"
            printVersion={printVersion}
            currentSoldListings={currentSoldListings}
            sorted={sorted}
            useExtendedTable={useExtendedTable}
          />

          <MarketIndicators
            quarterlyAreaTable={quarterlyAreaTable}
            currentArea={currentArea}
            useCity={useCity}
            printVersion={printVersion}
            quarterlyCityTable={quarterlyCityTable}
            agentData={agentData}
          />
        </div>
        {mlsAreaID === "SMA-392" ? (
          <MarketIndicators
            quarterlyAreaTable={quarterlyAreaTable}
            currentArea={currentArea}
            useCity={useCity}
            printVersion={printVersion}
            quarterlyCityTable={quarterlyCityTable}
            agentData={agentData}
            useSecondMarketIndicators={true}
            useSeparatedPropertyTypesCondoTownhouse={true}
          />
        ) : (
          <MQThreeAvailableHomes
            currentArea={currentArea}
            quarterlyAreaTable={quarterlyAreaTable}
            quarterlyCityTable={quarterlyCityTable}
            MQCityDetails={MQCityDetails}
            hoData={hoData}
            agentData={agentData}
            useCity={useCity}
            altVersion="ye2"
            printVersion={printVersion}
          />
        )}

        <QVFourEmailAndWebsiteFooter
          agentData={agentData}
          currentArea={currentArea}
          printVersion={printVersion}
        />
      </div>
    );
  }
}

export default YETwoSecondLeftV2;
